// services/TaskRequestService.ts

import { CreateAdministrativeTransactionRequest } from "../../interfaces/adminRequests/CreateAdministrativeTransactionRequest";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

interface ExtensionResponse {
    message: string;
    requestId?: number;   // present when SCs submit (pending) or PM/Owners submit (auditId=0)
}

interface ApiErrorResponse {
    error: string;
    details?: any;
}

export async function requestTaskExtension(
    authToken: string,
    taskId: number,
    payload: CreateAdministrativeTransactionRequest
): Promise<ApiResponse<ExtensionResponse>> {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/tasks/${taskId}/request-extension`;

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        // non-2xx?
        // if (!response.ok) {
        //   let err: any;
        //   try { err = await response.json(); }
        //   catch { /* ignore */ }
        //   return {
        //     error:   err?.error   ?? `HTTP ${response.status}`,
        //     details: err?.details ?? err,
        //   };
        // }

        // success
        const data = await response.json();
        return data;
    } catch (networkErr: any) {
        throw networkErr;
    }
}
